import React from 'react';
import {Header} from "@deere/ux.uxframe-react";
import UxfCustomNavbarReactRouter from "./WtyCustomNavigationTop";
import {useOktaAuth, withOktaAuth} from "@okta/okta-react";
import {useSelector} from "react-redux";
import {languageResponseData} from "../Translation/translationSerachSlice";

const WtyReportHeader = (props) => {

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse [key] || defaultText;
    };
    const history = props.history;
    const location = props.location;
    return (<div>
        <Header
            inputProps={{ariaLabel: "Search"}}
            submitBtnProps={{ariaLabel: "Search"}}
            clearBtnProps={{ariaLabel: "Clear search"}}
            logoLinkOnClick={() => {
                //history.push("/");
            }}
            logoLink="/"
            headerTitleComponent={<HeaderDropdown userName={props.userName}/>}
            skipLink="#content" pageHeadingLink="/home"
            pageHeadingLinkOnClick={e => {
                e.preventDefault();
                history.push("/");
            }}
            navbarCustom={true} search={false}
            pageHeading={translate('warrantyreport','Warranty Reports')}
        >
            <UxfCustomNavbarReactRouter/>
        </Header>
        {/*<WtyReportBreadcrumbs/>*/}
    </div>);
};

const HeaderDropdown = ({userName}) => {
    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse [key] || defaultText;
    };
    const {oktaAuth} = useOktaAuth();

    /*const handleLogOut = async () => {
        await oktaAuth.signOut();
    }*/
    /*return (<Dropdown alignRight>
            <Dropdown.Toggle variant="link" size="sm" aria-label="account menu">
                <span className="uxf-link-text">Hi, <span className="uxf-header-title-username">{userName}</span></span>
            </Dropdown.Toggle>
            <Dropdown.Menu renderOnMount>
                <Dropdown.Item as={Nav.Link} bsPrefix=" " className="uxf-back-link"><HomeIcon/> Menu</Dropdown.Item>
                <Dropdown.Item>My Account</Dropdown.Item>
                <Dropdown.Item>
                    <Button variant="link" onClick={handleLogOut}>Log Out</Button>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>);*/
    return (
        <>
            <span className="uxf-link-text">{translate('hi','Hi')},
                <span className="uxf-header-title-username">{userName}</span></span>
        </>
    )
}

export default withOktaAuth(WtyReportHeader);